import axios from "axios";
import { IP_URL } from "../constant";
const { decorate, observable, action } = require("mobx");
class Ip {
  list = [];

  async getList() {
    try {
      let response = await axios.get(IP_URL);
      let data = await response.data;
      this.list = data;
    } catch (error) {
      throw error;
    }
  }
  async addIp(data) {
    try {
      let response = await axios.post(IP_URL, {
        ipaddress: data.ipaddress,
        name: data.name,
      });
      await this.getList();
      return response;
    } catch (error) {
      throw error;
    }
  }
  async updateIp(data) {
    try {
      let response = await axios.put(IP_URL, {
        data: data,
      });
      await this.getList();
      return response;
    } catch (e) {
      throw e;
    }
  }
  async deleteIp(data) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      let response = await axios.delete(
        IP_URL,
        {
          data: { id: data._id },
        },
        config
      );
      await this.getList();
      return response;
    } catch (error) {
      throw error;
    }
  }
}

decorate(Ip, {
  list: observable,
  getList: action,
  addIp: action,
  deleteIp: action,
  updateIp: action,
});

const init = new Ip();
export default init;
